import { useContext, useState } from "react"
import React from "react"
import { useDispatch } from "react-redux"
import { Outlet } from "react-router-dom"
import {
  setLoadedPages,
  setFiltredCards,
  setMoreCards,
} from "../reducers/cards-filtred-for-gallery-slice"
import { getCardToFilter, getCompanyPointsApi } from "../../utils/api"
import { setIsLoading } from "../../services/reducers/preloader-slice"
import { setCompanyPointsToCheckbox } from "../reducers/cards-filtred-for-checkbox-points-slice"

const ActiveFiltersContext = React.createContext()

export const useActiveFilters = () => {
  return useContext(ActiveFiltersContext)
}

export const ActiveFiltersProvider = ({ children }) => {
  const dispatch = useDispatch()
  const [pageCount, setPageCount] = useState(1)
  const [filterToggle, setFilterToggle] = useState(false)
  // console.log(pageCount);
  const showMoreCardsBtn = (num = false) => {
    num ? setPageCount(num) : setPageCount(pageCount + 1)
  }
  const setNextPage = (
    orderingPoints,
    categoryPoints,
    countryPoints = "",
    sectorPoints,
    companyPoints,
    analysisPoints,
    subscriptionPoints,
    bondsPoints,

  ) => {
    dispatch(setLoadedPages(pageCount))
    if (
      localStorage.getItem("country_tag") === "?country_tag=-1" &&
      countryPoints === ""
    ) {
      countryPoints = "&country_tag=-1"
    }
    if (
      localStorage.getItem("country_tag") === "?country_tag=1" &&
      countryPoints === ""
    ) {
      countryPoints = "&country_tag=1"
    }
    return getCardToFilter(
      `${orderingPoints}${categoryPoints}${countryPoints}${sectorPoints}${companyPoints}${analysisPoints}${subscriptionPoints}${bondsPoints}`,
      pageCount
    )
  }
  const setAllGalleryCards = (
    orderingPoints,
    categoryPoints,
    countryPoints = "",
    sectorPoints,
    companyPoints,
    analysisPoints,
    subscriptionPoints,
    bondsPoints
  ) => {
    if (
      localStorage.getItem("country_tag") === "?country_tag=-1" &&
      countryPoints === ""
    ) {
      countryPoints = "&country_tag=-1"
    }
    if (
      localStorage.getItem("country_tag") === "?country_tag=1" &&
      countryPoints === ""
    ) {
      countryPoints = "&country_tag=1"
    }
    // logCheck()

    // dispatch(setLoadedPages(pageCount))
    getCardToFilter(
      `${orderingPoints}${categoryPoints}${countryPoints}${sectorPoints}${companyPoints}${analysisPoints}${subscriptionPoints}${bondsPoints}`,
      pageCount
    )
      .then((data) => {
        dispatch(setFiltredCards(data.results))
        dispatch(setMoreCards(data.results))
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setFilterToggle(true)
        dispatch(setIsLoading(false))
      })
  }
  // const defCountry = localStorage.getItem("country_tag")
  const setCompanyForFilters = (
    countryPointsForApi,
    sectorPointsForApi,
    categoryPointsForApi,
    analysisPoints,
    subscriptionPoints,
    bondsPoints
  ) => {
    if (
      countryPointsForApi === "" &&
      localStorage.getItem("country_tag") === "?country_tag=-1"
    ) {
      countryPointsForApi = "&country_tag=-1"
    }
    if (
      countryPointsForApi === "" &&
      localStorage.getItem("country_tag") === "?country_tag=1"
    ) {
      countryPointsForApi = "&country_tag=1"
    }
// console.log("analysisPoint, subscriptionPoints", analysisPoints, subscriptionPoints);
    // if (sectorPointsForApi !== "") {
      getCompanyPointsApi(
        `${countryPointsForApi}${sectorPointsForApi}${categoryPointsForApi}${bondsPoints ? "&bonds=true" : ""}${analysisPoints ? "&analysis=true" : ""}${subscriptionPoints ? "&subscription=2,4,5" : ""}`
      ).then((data) => {
        dispatch(setCompanyPointsToCheckbox(data))
      })
    // }
  }

  // const toggleCountry = (num) => {
  //   setSelectCountryPoint(num)
  // }
  return (
    <ActiveFiltersContext.Provider
      value={{
        pageCount,
        setPageCount,
        showMoreCardsBtn,
        setAllGalleryCards,
        setCompanyForFilters,
        filterToggle,
        setNextPage,
      }}
    >
      {/* children */}
      <Outlet />
    </ActiveFiltersContext.Provider>
  )
}
